import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import CompanyCouponEquipments from '@/components/Companies/CompanyCoupon/CompanyCouponEquipments';
import CompanyCouponForm from '@/components/Companies/CompanyCoupon/CompanyCouponForm';
import CompanyCouponCFSForm from '@/components/Companies/CompanyCoupon/CompanyCouponForm/CompanyCouponCFSForm';
import { DefaultRouteTabs } from '@/components/_common';
import TabsCustom from '@/components/_common/TabsCustom';
import {
  useCouponCompanyConfigCreate,
  useCouponCompanyConfigDetail,
  useCouponCompanyConfigDisable,
  useCouponCompanyConfigEnable,
} from '@/core/domain/coupon/company/company.hooks';
import { PageProps } from '@/types/PageProps';
import { Alert, Button, Divider, Empty, Form, Space } from 'antd';
import { useEffect, useState } from 'react';

const CompanyCouponPage: React.FC<PageProps> = ({ route }) => {
  const [tabKey, setTabKey] = useState('CFE');

  const { companyId, forms } = useCompanyFormContext();

  const [form] = Form.useForm(forms.companyCoupon);

  const { data: couponCompanyConfig, dataUpdatedAt } =
    useCouponCompanyConfigDetail(companyId);

  const hasActive = couponCompanyConfig?.defaultTaxConfig.active;

  const couponCompanyConfigCreate = useCouponCompanyConfigCreate();
  const couponCompanyConfigEnable = useCouponCompanyConfigEnable();
  const couponCompanyConfigDisable = useCouponCompanyConfigDisable();

  const toggleLoading =
    couponCompanyConfigEnable.isLoading || couponCompanyConfigDisable.isLoading;

  useEffect(() => {
    if (couponCompanyConfig && !forms.companyCoupon) {
      form.setFieldsValue(couponCompanyConfig);
    }
  }, [couponCompanyConfig, dataUpdatedAt, forms]);

  async function toggleActiveConfig(active: boolean) {
    try {
      if (!active) {
        form.resetFields();
        await couponCompanyConfigDisable.mutateAsync(companyId);
      } else {
        await couponCompanyConfigEnable.mutateAsync(companyId);
      }
    } catch {}
  }

  return (
    <DefaultRouteTabs
      baseKey={String(companyId)}
      permissions={route.permissions}
      basePath={`/app/registry/companies/${companyId}`}
      route={route.parent}
      extra={
        hasActive && (
          <Space>
            <Button
              onClick={() => toggleActiveConfig(false)}
              loading={couponCompanyConfigCreate.isLoading}
            >
              Desativar Cupom
            </Button>
          </Space>
        )
      }
    >
      {!hasActive && (
        <Empty
          description={
            <>
              <p>
                Não há uma configuração padrão de cupom fiscal para esta
                empresa. Deseja ativar o cupom fiscal?
              </p>

              <Button
                type="primary"
                onClick={() => toggleActiveConfig(true)}
                loading={toggleLoading}
              >
                Ativar cupon fiscal
              </Button>
            </>
          }
        />
      )}

      {hasActive && (
        <>
          <Alert
            type="warning"
            description="Cupom de serviço está em processo de análise interna."
            style={{ marginBottom: 16 }}
          />

          <TabsCustom activeKey={tabKey} onChange={setTabKey}>
            <TabsCustom.Item label="CFE" key="CFE">
              <CompanyCouponForm settings={couponCompanyConfig} />
            </TabsCustom.Item>

            <TabsCustom.Item label="CFS" key="CFS" disabled>
              <CompanyCouponCFSForm settings={couponCompanyConfig} />
            </TabsCustom.Item>
          </TabsCustom>
        </>
      )}

      <Divider />

      {hasActive && (
        <>
          <div
            style={
              !hasActive
                ? {
                    position: 'relative',
                    padding: 24,
                    borderRadius: 10,
                    overflow: 'hidden',
                  }
                : {}
            }
          >
            {!hasActive && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#0006',
                  zIndex: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <big>
                  <strong style={{ color: 'white' }}>
                    Configure e salve os dados de tributação dos itens, para
                    habilitar o gerenciamento de equipamentos.
                  </strong>
                </big>
              </div>
            )}
            <div style={!hasActive ? { opacity: 0.2 } : {}}>
              <CompanyCouponEquipments />
            </div>
          </div>
        </>
      )}
    </DefaultRouteTabs>
  );
};

export default CompanyCouponPage;
